import { schema } from './index'

export const interpolationPlaceholderNodeSpec = {
  // 插值占位符 have one attribute, their type, which must be one of
  // the types defined above.
  // Brontosaurs are still the default dino.
  attrs: { label: { default: 'xxx' } },
  inline: true,
  group: 'inline',
  draggable: true,
  atom: true,
  // These nodes are rendered as images with a `dino-type` attribute.
  // There are pictures for all dino types under /img/dino/.
  toDOM: node => ['div', {
    // 'dino-type': node.attrs.type,
    'interpolation-placeholder': node.attrs.label,
    // src: '/img/dino/' + node.attrs.type + '.png',
    // title: node.attrs.type,
    class: 'km-editor__interpolation-placeholder',
  }],
  // When parsing, such an image, if its type matches one of the known
  // types, is converted to a dino node.
  parseDOM: [{
    tag: 'div[interpolation-placeholder]',
    getAttrs: dom => {
      const type = dom.getAttribute('interpolation-placeholder')
      return {
        label: type,
      }
      //   return dinos.indexOf(type) > -1 ? { type } : false
    },
  }],
}

export const insertInterpolationPlaceholder = function (label, state, dispatch) {
  const interpolationPlaceholderType = schema.nodes.interpolationPlaceholder
  const { $from } = state.selection
  const index = $from.index()
  if (!$from.parent.canReplaceWith(index, index, interpolationPlaceholderType)) {
    return false
  }
  if (dispatch) {
    dispatch(state.tr.replaceSelectionWith(interpolationPlaceholderType.create({ label })))
  }
  return true
}
